<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-information-symbol</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Creación de tu Organización</p>
						</div>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-start">
              <div class="d-flex flex-column align-start flex-grow-1">
								<p class="mb-0 text-primary caption">Este panel funciona con un sistema oganizacional, con el cual podrás manejar tus colaboradores y cliente, para así permitir a diversos usuarios utilizar los servicios de tu organización.</p>
								<p class="mb-0 text-primary caption">Para esto necesitamos que crees tu primera organización, puedes crearla como empresa o como persona natural.</p>
              </div>
							<div class="d-flex flex-column justify-end align-end flex-1">
								<p class="mb-0 caption">Tipo de Organización: <b>{{isCompany ? 'Empresa':'Persona Natural'}}</b></p>
								<v-switch
									class="mt-0"
									color="#FF120B"
									dense
									hide-details
									v-model="isCompany"
								></v-switch>
							</div>
            </div>
            <v-form ref="form" v-model="validform" class="mt-6">
              <v-row class="mb-4 mt-2">
                <v-col cols="12" md="2" class="py-0">
									<v-avatar
										size="80"
										class="profile-avatar"
										@click="triggerFileInput"
									>
										<img :src="logoUrl" class="user-avatar" v-if="logoUrl && logoUrl"/>
										<v-icon v-else class="user-avatar" color="#524D4D" x-large>mdi-image</v-icon>
										<div class="logo-text">Modificar Logo</div>
									</v-avatar>
                  <v-file-input
										ref="fileInputLogo"
                    v-model="newCompany.logo"
                    show-size
                    outlined
                    dense
                    accept=".png,.jpg,.jpeg"
                    placeholder="Seleccione imagen de perfil"
                    prepend-inner-icon="mdi-image"
                    prepend-icon=""
										style="display: none;"
										@change="onFileSelected"
                  ></v-file-input>
								</v-col>
								<v-col cols="12" md="10" class="py-0">
									<v-row>
										<v-col cols="12" class="py-0">
											<v-text-field
												v-model="newCompany.legal_name"
												label="Nombre Legal (SII)"
												:placeholder="isCompany ? 'Ingrese el nombre legal de la empresa':'Ingrese su nombre'"
												outlined
												required
												dense
												:rules="requiredRule"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="py-0" v-if="isCompany">
											<v-text-field
												v-model="newCompany.name"
												label="Nombre de Fantasía"
												:placeholder="isCompany ? 'Ingrese el nombre de fantasía de la empresa':'Ingrese su nombre'"
												outlined
												required
												dense
												:rules="requiredRule"
											></v-text-field>
										</v-col>
									</v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newCompany.rut"
                    label="Rut"
                    placeholder="Ingrese el rut"
                    outlined
                    required
                    dense
										hint="Ingresa rut sin puntos ni guión"
                    :rules="rutRule"
										@blur="onBlurRut"
										@focus="onFocusRut"
										maxlength="9"
                  ></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newCompany.address"
                    label="Dirección"
                    placeholder="Ingrese direccción completa"
                    outlined
                    required
                    dense
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
								<v-col cols="12" class="py-0">
									<v-select
										v-model="newCompany.state_id"
										:items="$store.state.general.states"
										:loading="$store.state.general.loadingStates"
										:menu-props="{ top: true, offsetY: true }"
										item-text="name"
										item-value="id"
										label="Seleccione Región"
										outlined
										dense
										required
										:rules="requiredRule"
										@change="onChangeState"
									></v-select>
                </v-col>
								<v-col cols="12" class="py-0">
									<v-select
										v-model="newCompany.city_id"
										:items="$store.state.general.cities"
										:loading="$store.state.general.loadingCities"
										item-text="name"
										item-value="id"
										label="Seleccione Comuna"
										outlined
										dense
										required
										:disabled="!newCompany.state_id"
										:rules="requiredRule"
									></v-select>
                </v-col>
								<v-col cols="12" class="py-0" v-if="isCompany">
                  <v-text-field
                    v-model="newCompany.description"
                    label="Descripción"
                    placeholder="Ingrese una descripción para la empresa"
                    outlined
                    required
                    dense
                    :rules="requiredRule"
                  ></v-text-field>
								</v-col>
								<v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="newCompany.url"
                    label="Url sitio web"
                    placeholder="Ingrese url del sitio web"
                    outlined
                    required
                    dense
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" class="py-0">
									<v-select
										v-model="newCompany.responsible"
										:items="$store.state.users.usersList"
										:loading="$store.state.users.loadingUserList"
										item-text="profile.name"
										item-value="id"
										label="Usuario responsable"
										outlined
										dense
										required
										hide-details
										disabled
										:rules="requiredRule"
									>
										<template v-slot:item="data">
											<v-list-item-content>
												<v-list-item-title>{{data.item.profile.name}} - <span class="light-blue-text">[{{data.item.email}}]</span></v-list-item-title>
											</v-list-item-content>
										</template>
										<template #append-outer>
											<v-btn
												class="my-0"
												icon
												@click="addUser"
											>
												<v-icon>mdi-account-plus</v-icon>
											</v-btn>
										</template>
									</v-select>
								</v-col> -->
              </v-row>

              <v-row align="center">
                <v-col cols="12">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mx-2 my-1"
                      color="white"
                      raised
                      @click="closeModal"
                    >
                      <p class="mb-0 text-primary">Lo Haré Luego</p>
                    </v-btn>
                    <v-btn
                      class="mx-2 my-1"
                      color="#524D4D"
                      raised
                      dark
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      <p class="mb-0">Confirmar</p>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {createCompany, updateCompany} from '@/helpers/api/company'
import {validate, format, clean} from '@/helpers/rut.js'

export default {
  name: 'CompanyModalFirst',
  components: { },
	computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
	},
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
		isCompany: true,
    newCompany: {
			company_id: null,
			name: null,
			description: null,
			logo: null,
			url: null,
			rut: null,
			address: null,
			legal_name: null,
			responsible: null,
			state_id: null,
			city_id: null
    },
		logoUrl: null,
		rutRule: [
			v => validate(v) || 'Rut no válido'
		],
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  mounted(){
		this.newCompany = {...this.newCompany, ...{responsible: this.$store.state.user.userInfo.id}}
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		onBlurRut(){
			if(validate(this.newCompany.rut)){
				this.newCompany.rut = format(this.newCompany.rut)
			}
		},
		onFocusRut(){
			if(validate(this.newCompany.rut)){
				this.newCompany.rut = clean(this.newCompany.rut)
			}
		},
		onChangeState(state){
			this.$store.dispatch('general/getCities', state)
		},
    addUser() {
			this.$store.commit('users/setNewUserModalEditing', null)
			this.$store.commit('users/setNewUserModal', true)
    },
    triggerFileInput() {
      this.$refs.fileInputLogo.$el.querySelector('input[type="file"]').click();
    },
    onFileSelected(file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.logoUrl = e.target.result
        };
        reader.readAsDataURL(file)
      }
    },
    closeModal(){
      this.$store.commit('companies/setNewCompanyModalFirst', false)
      this.newCompany = {
				company_id: null,
				name: null,
				description: null,
				logo: null,
				url: null,
				rut: null,
				address: null,
				legal_name: null,
				responsible: null,
				state_id: null,
				city_id: null
			}
      this.validform = true
      this.loadingData = false
    },
    async sendForm(){
      if(this.$refs.form.validate()){
				this.loadingData = true
        const formData = new FormData()
        let newCompany = this.newCompany
				newCompany.rut = clean(newCompany.rut)
        Object.keys(newCompany).forEach((key) => {
          if(newCompany[key]) {
            formData.append(key, newCompany[key])
          }
        })
        const company = this.newCompany.company_id ? await updateCompany(formData):await createCompany(formData)
        if(company.code === 200){
          const messageData = {
            message: 'Se ha creado correctamente la empresa',
            title: 'Empresa creada',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.$store.dispatch('companies/getCompaniesList', {})
          this.setMessage(messageData)
					location.reload()
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
				this.loadingData = false
      }
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
		position: relative;
	}
	.logo-text{
		position: absolute;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		width: 100%;
		color: white;
		font-size: 12px;
		padding-bottom: 10px;
		padding-top: 3px;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>